import React from 'react';
import "./GoodItemStyles.scss";
import ButtonHint from "../../../../../../components/Buttons/buttonHint/ButtonHint";
import {MEDIA} from "../../../../../../utils/js/Const";

const GoodItem = ({ good, onAddProduct }) => {

    const handleOpenModal = () => {
        if (onAddProduct) {
            onAddProduct(good);
        }
    };

    return (
        <div className="good-item">
            <div className="good-item__image">
                <img
                    src={`${MEDIA}/api/attachments/${good?.attachments_guid}`}
                    alt={good.name}
                />
            </div>
            <div className="good-item__add-wrapper">
                <div className="good-item__info">
                    <div className="good-item__name">{good?.name || "Название товара не указано"}</div>
                </div>
                <ButtonHint
                    className="good-item__add-btn"
                    text="+"
                    funck={handleOpenModal}
                />
            </div>
        </div>
    );
};

export default GoodItem;